@file:OptIn(InternalResourceApi::class)

package banko.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/banko.composeapp.generated.resources/"

@delegate:ResourceContentHash(-359_234_476)
public val Res.string.change: StringResource by lazy {
      StringResource("string:change", "change", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5518, 22),
      ))
    }

@delegate:ResourceContentHash(1_758_802_362)
public val Res.string.create_game: StringResource by lazy {
      StringResource("string:create_game", "create_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5541, 35),
      ))
    }

@delegate:ResourceContentHash(-1_308_375_683)
public val Res.string.cta_go_ad_free: StringResource by lazy {
      StringResource("string:cta_go_ad_free", "cta_go_ad_free", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5577, 38),
      ))
    }

@delegate:ResourceContentHash(-2_031_052_556)
public val Res.string.customize_dice: StringResource by lazy {
      StringResource("string:customize_dice", "customize_dice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5616, 42),
      ))
    }

@delegate:ResourceContentHash(1_806_418_740)
public val Res.string.dice_2d_mode: StringResource by lazy {
      StringResource("string:dice_2d_mode", "dice_2d_mode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5756, 36),
      ))
    }

@delegate:ResourceContentHash(-397_854_701)
public val Res.string.dice_2d_mode_description: StringResource by lazy {
      StringResource("string:dice_2d_mode_description", "dice_2d_mode_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5659, 96),
      ))
    }

@delegate:ResourceContentHash(1_654_629_196)
public val Res.string.dice_report_legend_expected: StringResource by lazy {
      StringResource("string:dice_report_legend_expected", "dice_report_legend_expected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5793, 63),
      ))
    }

@delegate:ResourceContentHash(1_804_700_876)
public val Res.string.dice_report_legend_rolled: StringResource by lazy {
      StringResource("string:dice_report_legend_rolled", "dice_report_legend_rolled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5857, 41),
      ))
    }

@delegate:ResourceContentHash(1_260_875_006)
public val Res.string.dice_report_selected: StringResource by lazy {
      StringResource("string:dice_report_selected", "dice_report_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5899, 92),
      ))
    }

@delegate:ResourceContentHash(660_096_517)
public val Res.string.dice_report_sevens: StringResource by lazy {
      StringResource("string:dice_report_sevens", "dice_report_sevens", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5992, 86),
      ))
    }

@delegate:ResourceContentHash(-1_337_586_166)
public val Res.string.dice_section_base: StringResource by lazy {
      StringResource("string:dice_section_base", "dice_section_base", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6079, 33),
      ))
    }

@delegate:ResourceContentHash(-735_943_150)
public val Res.string.dice_section_hats: StringResource by lazy {
      StringResource("string:dice_section_hats", "dice_section_hats", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6113, 33),
      ))
    }

@delegate:ResourceContentHash(91_936_457)
public val Res.string.dice_trial_body: StringResource by lazy {
      StringResource("string:dice_trial_body", "dice_trial_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6147, 147),
      ))
    }

@delegate:ResourceContentHash(717_649_149)
public val Res.string.dice_trial_ready: StringResource by lazy {
      StringResource("string:dice_trial_ready", "dice_trial_ready", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6295, 64),
      ))
    }

@delegate:ResourceContentHash(-2_085_853_699)
public val Res.string.dice_trial_title: StringResource by lazy {
      StringResource("string:dice_trial_title", "dice_trial_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6360, 52),
      ))
    }

@delegate:ResourceContentHash(-2_145_901_743)
public val Res.string.dice_unlock_creator: StringResource by lazy {
      StringResource("string:dice_unlock_creator", "dice_unlock_creator", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6413, 55),
      ))
    }

@delegate:ResourceContentHash(1_629_683_837)
public val Res.string.dice_unlock_gold: StringResource by lazy {
      StringResource("string:dice_unlock_gold", "dice_unlock_gold", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6469, 36),
      ))
    }

@delegate:ResourceContentHash(1_396_009_569)
public val Res.string.dice_unlock_limited_plus: StringResource by lazy {
      StringResource("string:dice_unlock_limited_plus", "dice_unlock_limited_plus", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6506, 52),
      ))
    }

@delegate:ResourceContentHash(1_602_730_729)
public val Res.string.dice_unlock_lucky: StringResource by lazy {
      StringResource("string:dice_unlock_lucky", "dice_unlock_lucky", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6559, 45),
      ))
    }

@delegate:ResourceContentHash(-335_351_045)
public val Res.string.dice_unlock_practice: StringResource by lazy {
      StringResource("string:dice_unlock_practice", "dice_unlock_practice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6605, 60),
      ))
    }

@delegate:ResourceContentHash(-270_045_469)
public val Res.string.dice_unlock_silver: StringResource by lazy {
      StringResource("string:dice_unlock_silver", "dice_unlock_silver", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6666, 50),
      ))
    }

@delegate:ResourceContentHash(-33_682_615)
public val Res.string.doubles: StringResource by lazy {
      StringResource("string:doubles", "doubles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6717, 27),
      ))
    }

@delegate:ResourceContentHash(-2_028_209_229)
public val Res.string.enter_name: StringResource by lazy {
      StringResource("string:enter_name", "enter_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6745, 54),
      ))
    }

@delegate:ResourceContentHash(1_423_277_144)
public val Res.string.fall_harvest_desc: StringResource by lazy {
      StringResource("string:fall_harvest_desc", "fall_harvest_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6800, 109),
      ))
    }

@delegate:ResourceContentHash(920_827_411)
public val Res.string.fall_harvest_title: StringResource by lazy {
      StringResource("string:fall_harvest_title", "fall_harvest_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6910, 42),
      ))
    }

@delegate:ResourceContentHash(754_135_069)
public val Res.string.final_scores: StringResource by lazy {
      StringResource("string:final_scores", "final_scores", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6953, 40),
      ))
    }

@delegate:ResourceContentHash(1_131_630_992)
public val Res.string.find_public_game: StringResource by lazy {
      StringResource("string:find_public_game", "find_public_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7049, 40),
      ))
    }

@delegate:ResourceContentHash(1_396_765_226)
public val Res.string.find_public_game_title: StringResource by lazy {
      StringResource("string:find_public_game_title", "find_public_game_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6994, 54),
      ))
    }

@delegate:ResourceContentHash(828_495_737)
public val Res.string.finish_game: StringResource by lazy {
      StringResource("string:finish_game", "finish_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7090, 35),
      ))
    }

@delegate:ResourceContentHash(2_113_058_734)
public val Res.string.fireworks_mode_desc: StringResource by lazy {
      StringResource("string:fireworks_mode_desc", "fireworks_mode_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7126, 87),
      ))
    }

@delegate:ResourceContentHash(-882_071_652)
public val Res.string.fireworks_mode_title: StringResource by lazy {
      StringResource("string:fireworks_mode_title", "fireworks_mode_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7214, 48),
      ))
    }

@delegate:ResourceContentHash(27_589_605)
public val Res.string.game_code_format: StringResource by lazy {
      StringResource("string:game_code_format", "game_code_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7263, 36),
      ))
    }

@delegate:ResourceContentHash(860_843_550)
public val Res.string.game_code_placeholder: StringResource by lazy {
      StringResource("string:game_code_placeholder", "game_code_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7300, 73),
      ))
    }

@delegate:ResourceContentHash(334_785_959)
public val Res.string.game_length: StringResource by lazy {
      StringResource("string:game_length", "game_length", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7374, 35),
      ))
    }

@delegate:ResourceContentHash(-1_481_743_359)
public val Res.string.game_over: StringResource by lazy {
      StringResource("string:game_over", "game_over", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7456, 29),
      ))
    }

@delegate:ResourceContentHash(790_725_583)
public val Res.string.game_over_celebration: StringResource by lazy {
      StringResource("string:game_over_celebration", "game_over_celebration", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7410, 45),
      ))
    }

@delegate:ResourceContentHash(1_044_135_608)
public val Res.string.game_settings: StringResource by lazy {
      StringResource("string:game_settings", "game_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7486, 41),
      ))
    }

@delegate:ResourceContentHash(-924_248_081)
public val Res.string.game_stats_final_subtitle: StringResource by lazy {
      StringResource("string:game_stats_final_subtitle", "game_stats_final_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7528, 61),
      ))
    }

@delegate:ResourceContentHash(1_279_083_968)
public val Res.string.game_stats_live_subtitle: StringResource by lazy {
      StringResource("string:game_stats_live_subtitle", "game_stats_live_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7590, 68),
      ))
    }

@delegate:ResourceContentHash(-106_171_078)
public val Res.string.game_stats_title: StringResource by lazy {
      StringResource("string:game_stats_title", "game_stats_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7659, 40),
      ))
    }

@delegate:ResourceContentHash(30_250_224)
public val Res.string.ginko_double_trouble_desc: StringResource by lazy {
      StringResource("string:ginko_double_trouble_desc", "ginko_double_trouble_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7700, 69),
      ))
    }

@delegate:ResourceContentHash(-1_972_808_999)
public val Res.string.ginko_double_trouble_title: StringResource by lazy {
      StringResource("string:ginko_double_trouble_title", "ginko_double_trouble_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7770, 54),
      ))
    }

@delegate:ResourceContentHash(-1_863_780_220)
public val Res.string.ginko_event_all_in_desc: StringResource by lazy {
      StringResource("string:ginko_event_all_in_desc", "ginko_event_all_in_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7825, 111),
      ))
    }

@delegate:ResourceContentHash(1_201_941_066)
public val Res.string.ginko_event_all_in_title: StringResource by lazy {
      StringResource("string:ginko_event_all_in_title", "ginko_event_all_in_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7937, 48),
      ))
    }

@delegate:ResourceContentHash(1_317_255_732)
public val Res.string.ginko_event_danger_zone_desc: StringResource by lazy {
      StringResource("string:ginko_event_danger_zone_desc", "ginko_event_danger_zone_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7986, 72),
      ))
    }

@delegate:ResourceContentHash(879_573_811)
public val Res.string.ginko_event_danger_zone_title: StringResource by lazy {
      StringResource("string:ginko_event_danger_zone_title", "ginko_event_danger_zone_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8059, 53),
      ))
    }

@delegate:ResourceContentHash(-2_022_429_518)
public val Res.string.ginko_event_heist_window_desc: StringResource by lazy {
      StringResource("string:ginko_event_heist_window_desc", "ginko_event_heist_window_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8113, 97),
      ))
    }

@delegate:ResourceContentHash(-1_158_486_297)
public val Res.string.ginko_event_heist_window_title: StringResource by lazy {
      StringResource("string:ginko_event_heist_window_title", "ginko_event_heist_window_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8211, 54),
      ))
    }

@delegate:ResourceContentHash(-218_573_010)
public val Res.string.ginko_event_hot_streak_desc: StringResource by lazy {
      StringResource("string:ginko_event_hot_streak_desc", "ginko_event_hot_streak_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8266, 79),
      ))
    }

@delegate:ResourceContentHash(-1_742_406_728)
public val Res.string.ginko_event_hot_streak_title: StringResource by lazy {
      StringResource("string:ginko_event_hot_streak_title", "ginko_event_hot_streak_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8346, 52),
      ))
    }

@delegate:ResourceContentHash(-781_400_235)
public val Res.string.ginko_event_last_call_desc: StringResource by lazy {
      StringResource("string:ginko_event_last_call_desc", "ginko_event_last_call_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8399, 130),
      ))
    }

@delegate:ResourceContentHash(1_289_918_503)
public val Res.string.ginko_event_last_call_title: StringResource by lazy {
      StringResource("string:ginko_event_last_call_title", "ginko_event_last_call_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8530, 47),
      ))
    }

@delegate:ResourceContentHash(874_091_966)
public val Res.string.ginko_event_mystery_surge_desc: StringResource by lazy {
      StringResource("string:ginko_event_mystery_surge_desc", "ginko_event_mystery_surge_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8578, 90),
      ))
    }

@delegate:ResourceContentHash(1_678_368_865)
public val Res.string.ginko_event_mystery_surge_title: StringResource by lazy {
      StringResource("string:ginko_event_mystery_surge_title", "ginko_event_mystery_surge_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8669, 59),
      ))
    }

@delegate:ResourceContentHash(149_062_881)
public val Res.string.ginko_flipside_desc: StringResource by lazy {
      StringResource("string:ginko_flipside_desc", "ginko_flipside_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8729, 75),
      ))
    }

@delegate:ResourceContentHash(-1_900_149_389)
public val Res.string.ginko_flipside_title: StringResource by lazy {
      StringResource("string:ginko_flipside_title", "ginko_flipside_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8805, 40),
      ))
    }

@delegate:ResourceContentHash(853_780_653)
public val Res.string.ginko_high_stakes_desc: StringResource by lazy {
      StringResource("string:ginko_high_stakes_desc", "ginko_high_stakes_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8846, 62),
      ))
    }

@delegate:ResourceContentHash(1_949_058_777)
public val Res.string.ginko_high_stakes_title: StringResource by lazy {
      StringResource("string:ginko_high_stakes_title", "ginko_high_stakes_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8909, 47),
      ))
    }

@delegate:ResourceContentHash(1_548_910_645)
public val Res.string.ginko_jackpot_desc: StringResource by lazy {
      StringResource("string:ginko_jackpot_desc", "ginko_jackpot_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8957, 54),
      ))
    }

@delegate:ResourceContentHash(733_210_573)
public val Res.string.ginko_jackpot_title: StringResource by lazy {
      StringResource("string:ginko_jackpot_title", "ginko_jackpot_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9012, 39),
      ))
    }

@delegate:ResourceContentHash(1_467_687_456)
public val Res.string.ginko_lockdown_desc: StringResource by lazy {
      StringResource("string:ginko_lockdown_desc", "ginko_lockdown_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9052, 71),
      ))
    }

@delegate:ResourceContentHash(-1_742_777_414)
public val Res.string.ginko_lockdown_title: StringResource by lazy {
      StringResource("string:ginko_lockdown_title", "ginko_lockdown_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9124, 40),
      ))
    }

@delegate:ResourceContentHash(-2_085_152_278)
public val Res.string.ginko_mystery_pot_label: StringResource by lazy {
      StringResource("string:ginko_mystery_pot_label", "ginko_mystery_pot_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9165, 47),
      ))
    }

@delegate:ResourceContentHash(-1_220_537_087)
public val Res.string.halloween_desc: StringResource by lazy {
      StringResource("string:halloween_desc", "halloween_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9213, 122),
      ))
    }

@delegate:ResourceContentHash(-1_021_661_371)
public val Res.string.halloween_title: StringResource by lazy {
      StringResource("string:halloween_title", "halloween_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9336, 35),
      ))
    }

@delegate:ResourceContentHash(17_693_391)
public val Res.string.host_greeting: StringResource by lazy {
      StringResource("string:host_greeting", "host_greeting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9372, 37),
      ))
    }

@delegate:ResourceContentHash(-822_100_703)
public val Res.string.hosted_by: StringResource by lazy {
      StringResource("string:hosted_by", "hosted_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9410, 37),
      ))
    }

@delegate:ResourceContentHash(318_087_177)
public val Res.string.how_to_play: StringResource by lazy {
      StringResource("string:how_to_play", "how_to_play", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10189, 35),
      ))
    }

@delegate:ResourceContentHash(715_789_187)
public val Res.string.how_to_play_desc: StringResource by lazy {
      StringResource("string:how_to_play_desc", "how_to_play_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9448, 740),
      ))
    }

@delegate:ResourceContentHash(1_288_993_296)
public val Res.string.how_to_win: StringResource by lazy {
      StringResource("string:how_to_win", "how_to_win", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10333, 34),
      ))
    }

@delegate:ResourceContentHash(537_839_187)
public val Res.string.how_to_win_desc: StringResource by lazy {
      StringResource("string:how_to_win_desc", "how_to_win_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10225, 107),
      ))
    }

@delegate:ResourceContentHash(-14_283_808)
public val Res.string.invite_friends: StringResource by lazy {
      StringResource("string:invite_friends", "invite_friends", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10368, 42),
      ))
    }

@delegate:ResourceContentHash(-1_667_033_596)
public val Res.string.invite_only: StringResource by lazy {
      StringResource("string:invite_only", "invite_only", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10499, 35),
      ))
    }

@delegate:ResourceContentHash(-2_026_850_306)
public val Res.string.invite_only_description: StringResource by lazy {
      StringResource("string:invite_only_description", "invite_only_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10411, 87),
      ))
    }

@delegate:ResourceContentHash(1_337_094_512)
public val Res.string.invite_share_message: StringResource by lazy {
      StringResource("string:invite_share_message", "invite_share_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10535, 164),
      ))
    }

@delegate:ResourceContentHash(296_037_527)
public val Res.string.join_game: StringResource by lazy {
      StringResource("string:join_game", "join_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10700, 29),
      ))
    }

@delegate:ResourceContentHash(-1_683_660_426)
public val Res.string.join_public_game: StringResource by lazy {
      StringResource("string:join_public_game", "join_public_game", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10730, 32),
      ))
    }

@delegate:ResourceContentHash(685_047_018)
public val Res.string.kept_points: StringResource by lazy {
      StringResource("string:kept_points", "kept_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10763, 39),
      ))
    }

@delegate:ResourceContentHash(-1_720_204_160)
public val Res.string.leave_game_cancel: StringResource by lazy {
      StringResource("string:leave_game_cancel", "leave_game_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10803, 33),
      ))
    }

@delegate:ResourceContentHash(1_516_671_702)
public val Res.string.leave_game_confirm: StringResource by lazy {
      StringResource("string:leave_game_confirm", "leave_game_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10837, 34),
      ))
    }

@delegate:ResourceContentHash(757_253_491)
public val Res.string.leave_game_message_local: StringResource by lazy {
      StringResource("string:leave_game_message_local", "leave_game_message_local", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10872, 136),
      ))
    }

@delegate:ResourceContentHash(-65_830_210)
public val Res.string.leave_game_message_network: StringResource by lazy {
      StringResource("string:leave_game_message_network", "leave_game_message_network", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11290, 122),
      ))
    }

@delegate:ResourceContentHash(-1_459_734_460)
public val Res.string.leave_game_message_network_host: StringResource by lazy {
      StringResource("string:leave_game_message_network_host", "leave_game_message_network_host", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11166, 123),
      ))
    }

@delegate:ResourceContentHash(534_629_250)
public val Res.string.leave_game_message_network_host_last: StringResource by lazy {
      StringResource("string:leave_game_message_network_host_last", "leave_game_message_network_host_last", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11009, 156),
      ))
    }

@delegate:ResourceContentHash(944_044_485)
public val Res.string.leave_game_title: StringResource by lazy {
      StringResource("string:leave_game_title", "leave_game_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11413, 40),
      ))
    }

@delegate:ResourceContentHash(-1_662_528_354)
public val Res.string.lost_points: StringResource by lazy {
      StringResource("string:lost_points", "lost_points", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11454, 39),
      ))
    }

@delegate:ResourceContentHash(444_592_757)
public val Res.string.make_game_public_title: StringResource by lazy {
      StringResource("string:make_game_public_title", "make_game_public_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11494, 62),
      ))
    }

@delegate:ResourceContentHash(675_441_943)
public val Res.string.make_game_public_warning: StringResource by lazy {
      StringResource("string:make_game_public_warning", "make_game_public_warning", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11557, 280),
      ))
    }

@delegate:ResourceContentHash(322_059_874)
public val Res.string.make_host: StringResource by lazy {
      StringResource("string:make_host", "make_host", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11838, 29),
      ))
    }

@delegate:ResourceContentHash(2_023_264_441)
public val Res.string.make_public: StringResource by lazy {
      StringResource("string:make_public", "make_public", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11868, 35),
      ))
    }

@delegate:ResourceContentHash(1_229_838_066)
public val Res.string.manage_subscription: StringResource by lazy {
      StringResource("string:manage_subscription", "manage_subscription", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11904, 55),
      ))
    }

@delegate:ResourceContentHash(-96_684_480)
public val Res.string.minimum_players_required: StringResource by lazy {
      StringResource("string:minimum_players_required", "minimum_players_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11960, 100),
      ))
    }

@delegate:ResourceContentHash(-2_032_455_956)
public val Res.string.mixed_play: StringResource by lazy {
      StringResource("string:mixed_play", "mixed_play", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12241, 34),
      ))
    }

@delegate:ResourceContentHash(-1_792_406_529)
public val Res.string.mixed_play_desc: StringResource by lazy {
      StringResource("string:mixed_play_desc", "mixed_play_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12061, 179),
      ))
    }

@delegate:ResourceContentHash(1_435_057_306)
public val Res.string.mode_online: StringResource by lazy {
      StringResource("string:mode_online", "mode_online", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12276, 35),
      ))
    }

@delegate:ResourceContentHash(-496_827_841)
public val Res.string.multiple_devices: StringResource by lazy {
      StringResource("string:multiple_devices", "multiple_devices", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12518, 48),
      ))
    }

@delegate:ResourceContentHash(1_986_156_252)
public val Res.string.multiple_devices_desc: StringResource by lazy {
      StringResource("string:multiple_devices_desc", "multiple_devices_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12312, 205),
      ))
    }

@delegate:ResourceContentHash(819_600_294)
public val Res.string.mute_reactions: StringResource by lazy {
      StringResource("string:mute_reactions", "mute_reactions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12567, 50),
      ))
    }

@delegate:ResourceContentHash(-172_183_718)
public val Res.string.network_connection_lost: StringResource by lazy {
      StringResource("string:network_connection_lost", "network_connection_lost", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12618, 95),
      ))
    }

@delegate:ResourceContentHash(-1_124_048_433)
public val Res.string.new_player_name: StringResource by lazy {
      StringResource("string:new_player_name", "new_player_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12714, 43),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("change", Res.string.change)
  map.put("create_game", Res.string.create_game)
  map.put("cta_go_ad_free", Res.string.cta_go_ad_free)
  map.put("customize_dice", Res.string.customize_dice)
  map.put("dice_2d_mode", Res.string.dice_2d_mode)
  map.put("dice_2d_mode_description", Res.string.dice_2d_mode_description)
  map.put("dice_report_legend_expected", Res.string.dice_report_legend_expected)
  map.put("dice_report_legend_rolled", Res.string.dice_report_legend_rolled)
  map.put("dice_report_selected", Res.string.dice_report_selected)
  map.put("dice_report_sevens", Res.string.dice_report_sevens)
  map.put("dice_section_base", Res.string.dice_section_base)
  map.put("dice_section_hats", Res.string.dice_section_hats)
  map.put("dice_trial_body", Res.string.dice_trial_body)
  map.put("dice_trial_ready", Res.string.dice_trial_ready)
  map.put("dice_trial_title", Res.string.dice_trial_title)
  map.put("dice_unlock_creator", Res.string.dice_unlock_creator)
  map.put("dice_unlock_gold", Res.string.dice_unlock_gold)
  map.put("dice_unlock_limited_plus", Res.string.dice_unlock_limited_plus)
  map.put("dice_unlock_lucky", Res.string.dice_unlock_lucky)
  map.put("dice_unlock_practice", Res.string.dice_unlock_practice)
  map.put("dice_unlock_silver", Res.string.dice_unlock_silver)
  map.put("doubles", Res.string.doubles)
  map.put("enter_name", Res.string.enter_name)
  map.put("fall_harvest_desc", Res.string.fall_harvest_desc)
  map.put("fall_harvest_title", Res.string.fall_harvest_title)
  map.put("final_scores", Res.string.final_scores)
  map.put("find_public_game", Res.string.find_public_game)
  map.put("find_public_game_title", Res.string.find_public_game_title)
  map.put("finish_game", Res.string.finish_game)
  map.put("fireworks_mode_desc", Res.string.fireworks_mode_desc)
  map.put("fireworks_mode_title", Res.string.fireworks_mode_title)
  map.put("game_code_format", Res.string.game_code_format)
  map.put("game_code_placeholder", Res.string.game_code_placeholder)
  map.put("game_length", Res.string.game_length)
  map.put("game_over", Res.string.game_over)
  map.put("game_over_celebration", Res.string.game_over_celebration)
  map.put("game_settings", Res.string.game_settings)
  map.put("game_stats_final_subtitle", Res.string.game_stats_final_subtitle)
  map.put("game_stats_live_subtitle", Res.string.game_stats_live_subtitle)
  map.put("game_stats_title", Res.string.game_stats_title)
  map.put("ginko_double_trouble_desc", Res.string.ginko_double_trouble_desc)
  map.put("ginko_double_trouble_title", Res.string.ginko_double_trouble_title)
  map.put("ginko_event_all_in_desc", Res.string.ginko_event_all_in_desc)
  map.put("ginko_event_all_in_title", Res.string.ginko_event_all_in_title)
  map.put("ginko_event_danger_zone_desc", Res.string.ginko_event_danger_zone_desc)
  map.put("ginko_event_danger_zone_title", Res.string.ginko_event_danger_zone_title)
  map.put("ginko_event_heist_window_desc", Res.string.ginko_event_heist_window_desc)
  map.put("ginko_event_heist_window_title", Res.string.ginko_event_heist_window_title)
  map.put("ginko_event_hot_streak_desc", Res.string.ginko_event_hot_streak_desc)
  map.put("ginko_event_hot_streak_title", Res.string.ginko_event_hot_streak_title)
  map.put("ginko_event_last_call_desc", Res.string.ginko_event_last_call_desc)
  map.put("ginko_event_last_call_title", Res.string.ginko_event_last_call_title)
  map.put("ginko_event_mystery_surge_desc", Res.string.ginko_event_mystery_surge_desc)
  map.put("ginko_event_mystery_surge_title", Res.string.ginko_event_mystery_surge_title)
  map.put("ginko_flipside_desc", Res.string.ginko_flipside_desc)
  map.put("ginko_flipside_title", Res.string.ginko_flipside_title)
  map.put("ginko_high_stakes_desc", Res.string.ginko_high_stakes_desc)
  map.put("ginko_high_stakes_title", Res.string.ginko_high_stakes_title)
  map.put("ginko_jackpot_desc", Res.string.ginko_jackpot_desc)
  map.put("ginko_jackpot_title", Res.string.ginko_jackpot_title)
  map.put("ginko_lockdown_desc", Res.string.ginko_lockdown_desc)
  map.put("ginko_lockdown_title", Res.string.ginko_lockdown_title)
  map.put("ginko_mystery_pot_label", Res.string.ginko_mystery_pot_label)
  map.put("halloween_desc", Res.string.halloween_desc)
  map.put("halloween_title", Res.string.halloween_title)
  map.put("host_greeting", Res.string.host_greeting)
  map.put("hosted_by", Res.string.hosted_by)
  map.put("how_to_play", Res.string.how_to_play)
  map.put("how_to_play_desc", Res.string.how_to_play_desc)
  map.put("how_to_win", Res.string.how_to_win)
  map.put("how_to_win_desc", Res.string.how_to_win_desc)
  map.put("invite_friends", Res.string.invite_friends)
  map.put("invite_only", Res.string.invite_only)
  map.put("invite_only_description", Res.string.invite_only_description)
  map.put("invite_share_message", Res.string.invite_share_message)
  map.put("join_game", Res.string.join_game)
  map.put("join_public_game", Res.string.join_public_game)
  map.put("kept_points", Res.string.kept_points)
  map.put("leave_game_cancel", Res.string.leave_game_cancel)
  map.put("leave_game_confirm", Res.string.leave_game_confirm)
  map.put("leave_game_message_local", Res.string.leave_game_message_local)
  map.put("leave_game_message_network", Res.string.leave_game_message_network)
  map.put("leave_game_message_network_host", Res.string.leave_game_message_network_host)
  map.put("leave_game_message_network_host_last", Res.string.leave_game_message_network_host_last)
  map.put("leave_game_title", Res.string.leave_game_title)
  map.put("lost_points", Res.string.lost_points)
  map.put("make_game_public_title", Res.string.make_game_public_title)
  map.put("make_game_public_warning", Res.string.make_game_public_warning)
  map.put("make_host", Res.string.make_host)
  map.put("make_public", Res.string.make_public)
  map.put("manage_subscription", Res.string.manage_subscription)
  map.put("minimum_players_required", Res.string.minimum_players_required)
  map.put("mixed_play", Res.string.mixed_play)
  map.put("mixed_play_desc", Res.string.mixed_play_desc)
  map.put("mode_online", Res.string.mode_online)
  map.put("multiple_devices", Res.string.multiple_devices)
  map.put("multiple_devices_desc", Res.string.multiple_devices_desc)
  map.put("mute_reactions", Res.string.mute_reactions)
  map.put("network_connection_lost", Res.string.network_connection_lost)
  map.put("new_player_name", Res.string.new_player_name)
}
